var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80922 0.662745C6.9589 0.20209 7.6106 0.202089 7.76028 0.662744L9.12638 4.86716C9.19331 5.07317 9.38529 5.21265 9.6019 5.21265H14.0227C14.507 5.21265 14.7084 5.83246 14.3166 6.11716L10.7401 8.71563C10.5648 8.84295 10.4915 9.06863 10.5585 9.27465L11.9246 13.4791C12.0742 13.9397 11.547 14.3228 11.1551 14.0381L7.57864 11.4396C7.4034 11.3123 7.1661 11.3123 6.99086 11.4396L3.41437 14.0381C3.02251 14.3228 2.49527 13.9397 2.64495 13.4791L4.01105 9.27465C4.07798 9.06863 4.00465 8.84295 3.82941 8.71563L0.252923 6.11716C-0.138934 5.83246 0.0624527 5.21265 0.546814 5.21265H4.9676C5.18421 5.21265 5.37619 5.07317 5.44312 4.86716L6.80922 0.662745Z",
    fill: "#F2CF63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar3);
export default __webpack_public_path__ + "static/media/Star3.c23978928a4266f780b9ae2b7981f23f.svg";
export { ForwardRef as ReactComponent };